// eslint-disable-next-line import/no-unresolved
import { captureException as sentryCaptureException } from '@sentry/nextjs';

function captureException(error: any): void {
  sentryCaptureException(error);

  if (typeof process?.env?.STORYBOOK_ENV !== 'undefined') {
    console.error(error);
  }
}

export default captureException;
